import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Table } from 'react-bootstrap/lib';
import { Tooltip, OverlayTrigger } from 'react-bootstrap/lib';

export default class DataCutsList extends Component {
  static propTypes = {
    isMatch: PropTypes.bool,
    renderHeaderContent: PropTypes.func,
    renderRowContent: PropTypes.func,
    rows: PropTypes.array,
    clickHandler: PropTypes.func,
    itemId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    extraClass: PropTypes.string,
    isFavorites: PropTypes.bool
  };

  constructor(props) {
    super(props);
    this.getActionCol = this.getActionCol.bind(this);
  }

  shouldComponentUpdate(nextProps) {
    if (this.props.rows === nextProps.rows) {
      return false;
    }
    return true;
  }

  getActionCol(row) {
    const isFavorites = this.props.isFavorites;
    const tooltipRemoveMatch = <Tooltip id="tooltipRemoveMatch">Remove this favorite</Tooltip>;
    const tooltipMakeMatch = <Tooltip id="tooltipMakeMatch">Make this a favorite</Tooltip>;
    const iconClass = isFavorites ? 'icon-star icon-star--favorite' : 'icon-star icon-star--available';
    return (
      <OverlayTrigger placement="top" overlay={isFavorites ? tooltipRemoveMatch : tooltipMakeMatch}>
        <span
          className={iconClass}
          id="fav-star"
          onClick={this.props.clickHandler.bind(null, row, this.props.itemId)}
        />
      </OverlayTrigger>
    );
  }

  renderFavorites(rows) {
    const isFavorites = this.props.isFavorites || false;
    return rows
      .filter(row => row.job_scope_checked === isFavorites)
      .map(row => {
        return <tr key={row.unique_identifier}>{this.props.renderRowContent(row, this.getActionCol)}</tr>;
      });
  }

  renderFiltered(rows) {
    // Renders the non-favorited rows in the second data cuts table.
    const isFavorites = this.props.isFavorites || false;
    const isMatch = this.props.isMatch || false;

    return (
      // the first filter returns all non-favorited items, then second filter returns only those matching the search query
      rows
        .filter(row => row.job_scope_checked === isFavorites)
        .filter(row => row.match === isMatch || row.match === undefined)
        .map(row => {
          return <tr key={row.unique_identifier}>{this.props.renderRowContent(row, this.getActionCol)}</tr>;
        })
    );
  }

  render() {
    const { rows, extraClass, renderHeaderContent } = this.props;
    const isFavorites = this.props.isFavorites || false;

    const emptyMessage = (
      <div className="data-cuts-list--empty">
        <h2 className="data-cuts-list__heading">
          <i className="icon-folder-open-empty" />
          No survey data cuts to display
        </h2>
      </div>
    );

    let body = '';
    if (rows && rows.length > 0) {
      if (isFavorites) {
        body = this.renderFavorites(rows);
      } else {
        body = this.renderFiltered(rows);
      }
    }

    return (
      <div className={extraClass || ''}>
        <Table>
          <thead>
            <tr>{renderHeaderContent()}</tr>
          </thead>
          {body ? <tbody className={'table__body'}>{body}</tbody> : null}
        </Table>
        {!rows || !rows.length ? emptyMessage : ''}
      </div>
    );
  }
}
